import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "uefa-player-stat",
  "data-slider-pane": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_uefa_player_table = _resolveComponent("uefa-player-table")!
  const _component_widget_block = _resolveComponent("widget-block")!

  return _withDirectives((_openBlock(), _createBlock(_component_widget_block, {
    title: _ctx.title,
    "show-divider": !!_ctx.title,
    "show-slider": true,
    "btn-label": _ctx.btnLabel,
    "btn-url": _ctx.btnUrl
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playerStat, (stat) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (stat.items.length)
              ? (_openBlock(), _createBlock(_component_uefa_player_table, {
                  key: 0,
                  class: "uefa-player-stat__block",
                  title: stat.title,
                  contents: stat.items
                }, null, 8, ["title", "contents"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ])
    ]),
    _: 1
  }, 8, ["title", "show-divider", "btn-label", "btn-url"])), [
    [_vShow, Object.values(_ctx.playerStat).some(stat => stat.items.length)]
  ])
}